import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { userSelector } from '../appStore/commonSlice';
import { ROLES } from '../const';

/**
 * Chequea que el usuario actual tenga al menos uno de los roles en el listado proporcionado
 */
export const useCheckRoles = (rolesToCheck: string | string[] = []): boolean => {
  const user = useSelector(userSelector);
  const userRoles = user?.roles;
  const checkArray = Array.isArray(rolesToCheck) ? rolesToCheck : [rolesToCheck];

  // Asumo true para no redireccionar al home de forma inmediata
  const [authorized, setAuthorized] = useState<boolean>(true);

  useEffect(() => {
    if (!userRoles) setAuthorized(false);
    else {
      setAuthorized(userRoles.some((role: string) => checkArray.includes(role)));
    }
  }, [userRoles]);

  return authorized;
};

export const getNombresRoles = (rolToCast: Record<string, string>): string => {
  var rol = '';
  for (var r in rolToCast) {
    if (rolToCast[r] === ROLES.ADMIN) rol += 'ADMIN ';
    if (rolToCast[r] === ROLES.GUEST) rol += 'INVITADO ';
    if (rolToCast[r] === ROLES.USER) rol += 'USUARIO ';
    if (rolToCast[r] === ROLES.COMITE) rol += 'COMITE ';
    if (rolToCast[r] === ROLES.DIRECTOR) rol += 'DIRECTOR ';
    if (rolToCast[r] === ROLES.LEGALES) rol += 'LEGALES ';
  }
  return rol;
};
